import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'kg-tooltip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tooltip" [ngClass]="'tooltip-' + tooltipPosition">
      <div class="tooltip-text">{{ tooltipText }}</div>
    </div>
  `,
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  @Input() tooltipText!: string;
  @Input() tooltipPosition = 'top';
}
